export const CODEOWNERS_PATH = '.github/CODEOWNERS';

const TECH_LEAD_PLACEHOLDER = /@tech-lead(?![\w-])/g;

/**
 * Makes the person who created the repository its default code owner, in
 * place of the template's `@tech-lead` placeholder. The team placeholders stay
 * for setup-config.yaml to fill.
 */
export const assignCreatorAsCodeOwner = (content: string, login: string) =>
  content.replaceAll(TECH_LEAD_PLACEHOLDER, `@${login}`);

const OWNER_HANDLE = /^@[\w.-]+(\/[\w.-]+)?$/;

/**
 * Who owns the whole repository: the owners of CODEOWNERS' last `*` rule
 * (later rules win), without placeholders setup has not filled yet.
 */
export const defaultCodeOwners = (content: string) => {
  const rule = content
    .split('\n')
    .map(line => line.replace(/#.*/, '').trim().split(/\s+/))
    .filter(([pattern]) => pattern === '*')
    .at(-1);
  return (rule?.slice(1) ?? []).filter(
    owner => OWNER_HANDLE.test(owner) && owner !== '@tech-lead',
  );
};
